import React from "react"

const MiniDivider = ({additionalCss}) => {
  const style = {
    width: 50,
    borderBottom: "1px solid black",
    margin: "10px 0 20px 0px",
    ...additionalCss
  }

  return <div css={style} />
}
export default MiniDivider